const emailValidation = (email) => {
  const emailValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/g;
  return emailValid.test(email);
};

export default emailValidation;
